import {Button, Row} from "react-bootstrap";
import PropTypes from "prop-types";

export function ListItemButton(props) {
    const {children, onClick, className} = props
    return <Button onClick={onClick} className={`btn-light w-100 ${className}`}>
        <Row className={'g-0 '}>
            {children}
        </Row>
    </Button>
}

ListItemButton.propTypes = {onClick: PropTypes.func, className: PropTypes.string};